import {request,GETApi} from '../utils/request'
export const reportReducer =  request({reducerPath:'report',endpoints:(builder)=>{
    return {
      reportInfo:GETApi(builder,'/report/info'),//分页查询客户WebLicense信息
    }
}})
export const {useLazyReportInfoQuery} = reportReducer